<template>
<div class="text-danger input-error-text" v-if="validateAmountError && validateAmountError.length > 0">
{{validateAmountError}}
</div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  name: "ValidateAmountDecimals",
  props: ['amount','currency', 'currencyText'],
  computed: {
    ...mapGetters[("adminDataList")],
    validateAmountError() {
      return this.validatedText()
    }
  },
  methods: {
    validatedText() {
      if (this.adminDataList && this.adminDataList.currencyList){
        let allowedDecimals = 0
        if(this.currencyText && this.currencyText.length > 0) {
          allowedDecimals =
              this.currencyText ? this.adminDataList.currencyList.find(currency => currency.text === this.currencyText).decimal : 2
        } else {
          allowedDecimals =
              this.currency ? this.adminDataList.currencyList.find(currency => currency.value === this.currency).decimal : 2
        }

        allowedDecimals = parseInt(allowedDecimals)

        //Verify if amount begins with a decimal ex: '.922', would not be allowed
        if(this.amount && this.amount.length > 0 && this.amount.indexOf('.') === 0) {
          this.$emit('onValidationError', true)
          return 'Amount cannot start with a decimal (.)'
        }

        //Verify if amount has alpha chars ex: 'a.922', would not be allowed
        let alphaRegEx = /[a-zA-Z]/g;
        if(this.amount && this.amount.length > 0  && alphaRegEx.test(this.amount)) {
          this.$emit('onValidationError', true)
          return 'Amount cannot contain letters.'
        }

        //Verify if amount has multiple decimals ex: '1...922', would not be allowed
        if(this.amount && this.amount.split(".").length > 2) {
          this.$emit('onValidationError', true)
          return 'Incorrect amount value. Multiple decimal (.) not allowed'
        }

        //Verify if amount is not allowed in decimals ex: '1.00' for JPY currency, would not be allowed
        if(allowedDecimals === 0 && this.amount && this.amount.indexOf('.') !== -1) {
          this.$emit('onValidationError', true)
          return 'Please do not enter amount in decimal value'
        }

        //Validate number of decimals ex: '1.00' for USD currency is allowed but for some currency is not
        if(this.amount && this.amount.split('.') && this.amount.split('.')[1]) {
          if(this.amount.split('.')[1].length > allowedDecimals) {
            this.$emit('onValidationError', true)
            return 'Please enter upto ' + allowedDecimals + ' digits after decimals'
          }
        }

        //Default return validation success.
        this.$emit('onValidationError', false)
        return ''
      }

    }
  }
}
</script>

<style scoped>

</style>